declare namespace $ {

	type $mol_paragraph__title_bog_blitz_lobby_waiting_1 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_waiting['quiz_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_waiting_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_waiting_3 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_waiting['counter_string'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $bog_blitz_lobby_waiting extends $mol_page {
		Quiz_title( ): $mol_paragraph
		Waiting_message( ): $mol_paragraph
		Counter( ): $mol_paragraph
		Players( ): $bog_blitz_lobby_players
		Head( ): any
		counter_string( ): string
		quiz_title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=waiting.view.tree.d.ts.map